import { AutogenModelQuoteStop, AutogenRowQuoteStop } from "./autogen/AutogenModelQuoteStop";

export class ModelQuoteStop extends AutogenModelQuoteStop<RowQuoteStop> {
	constructor() {
		super(RowQuoteStop);
	}
}

export class RowQuoteStop extends AutogenRowQuoteStop {
}